import { FONT_SIZE, mq, Button as _Button, Icon as _Icon, COLOR } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DivHeaderSummary = styled.div`
  display: flex;
  align-items: center;
  margin-top: 32px;
  font-size: ${FONT_SIZE.L}px;

  ${mq.sp} {
    flex-direction: column;
    align-items: flex-start;
    margin-top: 16px;
    font-size: ${FONT_SIZE.M}px;
  }
`;

export const DivSpanWrapper = styled.div`
  padding-top: 4px;
  margin-left: 8px;

  ${mq.sp} {
    margin-top: 8px;
    padding-top: 0px;
    margin-left: 0px;
  }
`;

export const SpanValue = styled.span`
  margin-left: 8px;
`;

export const SpanCommentCount = styled.span`
  font-size: ${FONT_SIZE.M}px;
  color: ${COLOR.GRAY500.code};

  ${mq.sp} {
    font-size: ${FONT_SIZE.S}px;
  }
`;

const BUTTON_HEIGHT = 80;

export const DivReviewPosition = styled.div<{ isLastItem: boolean }>`
  position: relative;
  ${({ isLastItem }) => isLastItem && `margin-bottom: ${BUTTON_HEIGHT}px;`}
`;

export const BtnDropdown = styled.button<{ isLastItem: boolean }>`
  position: absolute;
  bottom: ${({ isLastItem }) => (isLastItem ? `-${BUTTON_HEIGHT}px` : `-2px`)};
  cursor: pointer;
  height: ${BUTTON_HEIGHT}px;
  width: 100%;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, ${COLOR.GRAY100.code} 100%);
`;

export const Icon = styled(_Icon)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const DivAddReviewWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const Button = styled(_Button)`
  width: 240px;
  height: 48px;
`;
